import type { ZoneEquipmentSignal } from "@/lib/api/agent";
import type { VisibleSignalFilter } from "../datapoints/visible-signal-filter";
import {
  compareCoveredNativeIds,
  zoneCompareHistoryNames,
} from "../datapoints/zone-syote-rows";

// Builds the render-time filter for a zone's DataPointsExplorer.
//
// The zone is the downstream (same role as the AHU for chiller Syöte): native
// Signaalit plus compare publishes listed under the zone as connection_source
// rows. Equipment history is not inlined as a second source group.
export function build_zone_visible_signals(
  zone_id: string,
  live_signal_names: string[],
  equipment_signals: ZoneEquipmentSignal[],
): VisibleSignalFilter {
  const covered_native = compareCoveredNativeIds(equipment_signals);
  const names = [
    ...live_signal_names.filter((name) => !covered_native.has(name)),
    ...zoneCompareHistoryNames(equipment_signals),
  ];
  if (names.length === 0) return [];
  return [{ source_id: zone_id, names }];
}
